import { render, staticRenderFns } from "./addRoomRepairList.vue?vue&type=template&id=f83e60ba&scoped=true"
import script from "./addRoomRepairList.vue?vue&type=script&lang=js"
export * from "./addRoomRepairList.vue?vue&type=script&lang=js"
import style0 from "./addRoomRepairList.vue?vue&type=style&index=0&id=f83e60ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83e60ba",
  null
  
)

export default component.exports